

const bosaltmaData = {
    locationData: {
        il: "",
        ilId: "",
        ilce: "",
        ilceId: "",
        
        lat: "",
        lng: "",
        location: "",
        bolge: "",
        locationId: "",

        googleLat: 38.75,
        googleLng: 33.75,
        googleLocation: "",
        googleSearchText: "",
        isGoogleAddressSelected: false,
        isfirstChanged: false,
      },

    adres: "",
    adresTarif: "",
    adresKaydedilsinMi: false,
    adresBaslik: "",
    date: "",
    dateEngec: "",
    saatBaslangic: "",
    saatBitis: "",
    //! kendinden önceki tarihle farkı kontrol ediyor (ffk)
    dateInfo:false,
    //! kendinden sonra tarihle farkı kontrol ediyor (ffk)
    dateAfterInfo:false,
    //! bugünün tarihinden önce bir tarih girildi mi (ffk)
    currentDateControl:false,
    saatAllTime: false,
    locationType: "bosaltma",

    sevkBicimleri:[
        {
            id: 1,
            name: "Forkliftle",
            status: false,
        },
        {
            id: 2,
            name: "Rampadan",
            status: false,
        },
        {
            id: 3,
            name: "Vinçle",
            status: false,
        },
        {
            id: 4,
            name: "Elle",
            status: false,
        },
        {
            id: 5,
            name: "Dökme",
            status: false,
        },
        {
            id: 6,
            name: "Yandan",
            status: false,
        },
        {
            id: 7,
            name: "Babalar Çıksın",
            status: false,
        }
    ]
}


export default bosaltmaData